import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class DestinationsProviderService {


    all_deals_encoded = 'All+Deals';
    // public constructor(private http:HttpClient) {}

    constructor(private http: HTTP, private config: ConfigurationManager) { }




    getDestinations(data) {

        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };

        const params = {
            'Latitude': this.config.getLatitude + '',
            'Longitude': this.config.getLongitude + '',
            'SessionID': this.config.getSessionId,
            'ScreenTitle': data.ScreenTitle,
            'ProxyUI': this.config.getProxyUI,
            'ClubID': this.config.getClubCode,
            'FromNewDNR': 'true',
            'SearchTypeID': data.SearchTypeID
        };


        const url = this.config.environmentConfig.baseurl + 'dstns/v1';
        return this.http.get(url, params, headers);

    }

}
